import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetySettoriService
 * Client API per il catalogo dei settori/comparti aziendali (usati per
 * filtrare cataloghi e adempimenti del modulo Adempimenti Sicurezza).
 */
export default class SafetySettoriService {
    static list = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/settori/list`;
            ApiService.postRequest(resolve, reject, url, {});
        });
    };
}
